<template>
  <div class="secondary-nav ml-auto">
    <ul class="navbar-nav">
      <li
        v-if="searchActive"
        title="Search"
        class="nav-item search"
      >
        <div class="nav-link">
          <button
            class="search"
            title="Site Search"
            @click="triggerShowHeaderSearch"
          >
            <span class="icon"><img src="~assets/menu-icons/search.svg"></span>
            <span class="nav-label">Search</span>
          </button>
        </div>
      </li>

      <!-- Shopping Cart -->
      <li
        v-if="ecommerceEnabled"
        class="nav-item cart-element"
      >
        <ecommerce-cart-block />
      </li>

      <!-- Login Form -->
      <li
        v-if="!loggedIn"
        class="nav-item login-element"
      >
        <user-login-popup />
      </li>

      <!-- My Portal Link -->
      <li
        v-if="loggedIn"
        class="nav-item"
      >
        <page-element-user-my-account />
        <template v-if="helpActive">
          <div class="context-help-container">
            <a
              href="javascript:"
              class="helper"
            >
              <b-btn
                v-b-popover.hover="'This brings you to your User Portal!'"
                title="Context Help"
              >
                <font-awesome-icon :icon="question" />
              </b-btn>
            </a>
          </div>
        </template>
      </li>

      <!-- Logout Link -->
      <!-- <li
        v-if="loggedIn"
        class="nav-item"
      >
        <user-logout />
      </li> -->
    </ul>
  </div>
</template>

<script>
import {faQuestion} from '@fortawesome/free-solid-svg-icons'

export default {
  name: 'user-actions',
  asyncComponents: (app) => {
    if (app.registry.getFeature('ecommerce')) {
      return [ 'ecommerce-cart-block' ]
    }
    else {
      return []
    }
  },
  props: {
    'helpActive': {
      default: false,
      type: Boolean,
      required: false
    }
  },
  computed: {
    question: function() { return faQuestion },
    searchActive() {
      return this.$store.state.registry.getFeature('search')
    },
    loggedIn: function() {
      return this.$store.getters['user/isLoggedIn']
    },
    ecommerceEnabled: function() {
      return this.$store.getters.getEcommerceEnabled
    }
  },
  methods: {
    triggerShowHeaderSearch: function() {
      this.$eventHub.$emit('showHeaderSearch')
    }
  }
}
</script>
